import uniq from 'lodash.uniqby';
import { filter } from '../../helpers/filtersHelpers';

/**
 * https://olymp-moscow.atlassian.net/browse/PGU-2409
 * поповер с количеством найденных офисов показывается только когда
 * количество выбранных офисов не равно количеству показываемых на карте
 */

const changeArrayByEnable = (arr, { id, enabled }) =>
  enabled ? uniq([...arr, id]) : arr.filter((item) => item !== id);

const changeFilterMiddleware = (action, state) => {
  const { payload } = action;
  const { fieldName, enabled, id } = payload;

  let newFilters;
  if (fieldName === 'services') {
    newFilters = enabled ? [id.toString()] : [];
  } else {
    newFilters = changeArrayByEnable(state.filters[fieldName], {
      id,
      enabled,
    });
  }

  const filters = { ...state.filters, [fieldName]: newFilters };
  const { presentationalFilters } = state;

  const filteredOffices = filter(state.data.offices, filters);

  const newPresentationalFilters = {
    ...presentationalFilters,
    [fieldName]: presentationalFilters[fieldName].map((item) => ({
      ...item,
      enabled: item.id === id ? enabled : item.enabled,
    })),
  };

  return {
    ...state,
    filteredOffices,
    filters,
    presentationalFilters: newPresentationalFilters,
  };
};

export default changeFilterMiddleware;
